<template>
  <header>
    <a class="logo" href="/">
      <img alt="acf-logo" src="../assets/logo.svg" />
    </a>
    <nav class="nav">
      <a target="_blank" href="https://acfb.org">ACFB.ORG</a>
      <div class="menu-burger">
        <h2 @click="activateDrawer">MENU</h2>
        <div
          v-if="!$store.state.drawerListActive"
          @click="activateDrawer"
          class="burger"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div v-else @click="activateDrawer" class="x-btn">
          <img src="../assets/x-btn.svg" />
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: "Header",
  methods: {
    activateDrawer() {
      if (!this.$store.state.drawerListActive) {
        this.$store.commit("setDrawer", true);
      } else {
        this.$store.commit("setDrawer", false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/colors";
@import "../assets/styles/_breakpoints.scss";
* {
  margin: 0;
}
header {
  position: relative;
  z-index: 1000;
  box-sizing: border-box;
  box-shadow: 0 2px 46px rgba(0, 0, 0, 0.157397);
  background: $backWhite;
  padding: 18px 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @include media("<=tablet") {
    grid-gap: 10px;
  }
}
.logo {
  display: flex;
  align-items: center;
  width: 198px;
  height: 64px;
  color: #42b983;
  img {
    @include media("<=tablet") {
      width: 90px;
    }
  }
}
.menu-burger {
  font-family: "omnes-pro", sans-serif;
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 24px;
  h2 {
    font-size: 18px !important;
    cursor: pointer;
    transition: 0.3s ease transform;
    &:hover {
      transform: scale(1.2);
    }
  }
  @include media("<=tablet") {
    h2 {
      font-size: 14px !important;
    }
    grid-gap: 10px;
  }
}
.nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 24px;
  color: $orange;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  a {
    font-family: "omnes-pro", sans-serif;
    text-transform: uppercase;
    text-decoration: none;
    color: $grey;
    transition: 0.3s ease transform;
    @include media("<=tablet") {
      font-size: 14px;
    }
    &:hover {
      transform: scale(1.2);
    }
  }
  @include media("<=tablet") {
    grid-gap: 10px;
  }
}
.burger {
  width: 25px;
  height: 25px;
  border: 4px solid $orange;
  border-radius: 40% / 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background: $orange;
    border-color: white;
    span {
      background: white;
    }
  }
  span {
    background: $orange;
    width: 100%;
    border-radius: 10px;
    height: 4px;
    @include media("<=tablet") {
      height: 4px;
    }
  }
  @include media("<=tablet") {
    padding: 6px;
    width: 45px;
    height: 45px;
    box-sizing: border-box;
    border: 4px solid $orange;
  }
}
.x-btn {
  img {
    width: 45px;
    height: 45px;
  }
  cursor: pointer;
  @include media("<=tablet") {
    img {
      width: 45px;
      height: 45px;
    }
  }
}
</style>
